export default __webpack_public_path__ + "static/media/slide018.88e32064.jpg";